// extracted by mini-css-extract-plugin
module.exports = {"container":"signature_container__1Y8Yj","footer":"signature_footer__3jv73"};